import { render, staticRenderFns } from "./modal-form.vue?vue&type=template&id=3472a7c2&functional=true&"
import script from "./modal-form.vue?vue&type=script&lang=js&"
export * from "./modal-form.vue?vue&type=script&lang=js&"
import style0 from "./modal-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports